var _defs, _rect, _circle, _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle2, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarPlantClock = function SvgCalendarPlantClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 175,
    height: 150,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-plant-clock_svg__a",
    x1: 73.569,
    x2: 73.569,
    y1: 148.739,
    y2: -5.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C9D8",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 105.392,
    height: 131.424,
    x: 39.656,
    y: 9.202,
    fill: "url(#calendar-plant-clock_svg__a)",
    rx: 12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.629,
    cy: 22.707,
    r: 18.707,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#162958",
    d: "M171.044 74.367 130.916 143h40.128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M171.045 74.367 130.917 143h-91.26l39.372-68.633z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E3E7ED",
    d: "m95.447 79.463-33.289 58.44m51.254-58.44-33.289 58.44m50.984-58.44-33.289 58.44m50.724-58.44-33.288 58.44M74.406 94.259h75.865m-84.048 15.622h73.041m-80.428 15.316h73.063"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.339,
    cy: 102.451,
    fill: "#8C9CAE",
    rx: 5.16,
    ry: 6.466,
    transform: "rotate(30.586 109.339 102.451)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#345714",
    d: "m47.952 123.254 14.643-60.052s-16 30.744-17.867 61.568z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6CA03B",
    d: "M42.047 124.77s5.268-46.225 3.83-70.011c-1.437-23.787-10.291 74.109-10.291 74.109z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#345714",
    d: "M39.896 126.133S37.736 23.31 35.58 33.128s-2.155 95.738-2.155 95.738l6.47-2.733z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6CA03B",
    d: "M35.581 124.77S21.363 60.584 18.412 61.103s13.55 62.151 13.55 62.151l1.464 5.612z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#162958",
    d: "M17.773 95.945a1.774 1.774 0 1 0 0-3.547 1.774 1.774 0 0 0 0 3.547m4.222-45.375a2.034 2.034 0 1 0 0-4.068 2.034 2.034 0 0 0 0 4.068m35.982 9.463a2.054 2.054 0 1 0 0-4.107 2.054 2.054 0 0 0 0 4.107"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#162958",
    strokeMiterlimit: 10,
    strokeWidth: 0.459,
    d: "m21.995 48.535 13.586 76.235-17.808-30.599M57.975 57.98s-15.69 41.873-15.208 70.887"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C9CAE",
    d: "M58.31 107.397H20.285v35.602H58.31z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#162958",
    strokeMiterlimit: 10,
    strokeWidth: 0.557,
    d: "M20.285 114.821H58.31m-38.025 9.364H58.31m-38.025-4.682H58.31m-38.025 9.364H58.31"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.829,
    cy: 41.69,
    r: 21.512,
    fill: "#162958"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.666,
    d: "M144.83 26.458V41.69l-8.646 7.247"
  })));
};
export { SvgCalendarPlantClock as ReactComponent };
export default "data:image/svg+xml;base64,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";